"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultSuccess = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

var DefaultSuccess = exports.DefaultSuccess = {
  financialServicesGuideUrl: 'https://www.petinsurance.com.au/forms-faqs-2/',
  extraNextStepInstruction: null,
  petPortalMessage: /*#__PURE__*/_react["default"].createElement("p", null, "As a valued customer, you can register for the Pet Portal where you can manage your policy and claims."),
  callCenterHoursMessage: /*#__PURE__*/_react["default"].createElement("p", null, "Our lines are open", /*#__PURE__*/_react["default"].createElement("strong", null, " Monday to Friday 8:00am to 8:00pm"), " (AET), excluding public holidays."),
  // Turn on myPetPass to true from layout to make myPetPass work.
  myPetPass: function myPetPass(isMobileMode) {
    return isMobileMode ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "myPetPassImage myPetPassImageHolder mobile mobileMyPetPassImage"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: "myPetPassImage",
      href: "https://mypetpass.com.au",
      rel: "noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: "https://petcdnstore.blob.core.windows.net/qt-assets/Non-prod/Common/MyPetPass_QT_infographic_300x600_mobile.png",
      alt: "As a pet insurance customer, unlock extra support and savings with myPetPass. Find out more at mypetpass.com.au"
    }))) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "myPetPassImage myPetPassImageHolder desktop desktopMyPetPassImage"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: "myPetPassImage",
      href: "https://mypetpass.com.au",
      rel: "noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: "https://petcdnstore.blob.core.windows.net/qt-assets/Non-prod/Common/MyPetPass_QT_infographic_600x300_desktop.png",
      alt: "As a pet insurance customer, unlock extra support and savings with myPetPass. Find out more at mypetpass.com.au"
    })));
  }
};